module.exports = __webpack_public_path__ + "img/stickers_0000_ls.4acf720b.png";